import { render, staticRenderFns } from "./UpdateAddressModal.vue?vue&type=template&id=a031239a&scoped=true"
import script from "./UpdateAddressModal.vue?vue&type=script&lang=js"
export * from "./UpdateAddressModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateAddressModal.vue?vue&type=style&index=0&id=a031239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a031239a",
  null
  
)

export default component.exports